<aig-modal class="aig-modal-doc" position="center" customMaxWidth="600px">
  <div class="u-p-8 u-pb-3" body>
    <div class="p-flexcc u-dir-col">
      <img src="./assets/images/logos/logo.svg" class="u-mb-3" />
      <div class="p-flecss">
        <p class="u-fs-18 u-fw-400 u-color-black u-mt-def">
          Este son los archivos previamente adjuntados.
        </p>
        <div class="aig-modal-doc__documents u-pt-2">
          <div *ngFor="let doc of documents">
            <p>{{ doc.nombre }}</p>
            <button (click)="downloadFile(doc)">Descargar</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="u-p-8 u-pt-def" buttons>
    <button
      class="e-btn--primary p-flexcc u-size-per-100"
      (click)="clickHide()"
    >
      <p class="u-fs-16 u-fw-600">Cerrar</p>
    </button>
  </div>
</aig-modal>
